import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SubFooter from '../components/SubFooter';
import Footer from '../components/Footer';
import PlacementPartners from '../components/PlacementImg';

// Import your existing images
import googleImg from "../assets/courses/google.png";
import fedImg from "../assets/courses/fed.png";
import ItcImg from "../assets/courses/itc.png";
import TcsImg from "../assets/courses/tcs.png";
import AmazonImg from "../assets/courses/amazon.png";
import accentImg from "../assets/courses/accenture.png";
import { Link } from 'react-router-dom';

// Student placement images
import placement1 from "../assets/placement comp/aastha.png";
import placement2 from "../assets/placement comp/aman.png";
import placement3 from "../assets/placement comp/arman.png";
import placement4 from "../assets/placement comp/asma.jpg";
import placement5 from "../assets/placement comp/b pharm.png";
import placement6 from "../assets/placement comp/mohit.png";
import placementBanner from "../assets/placement comp/placement.jpg";
import placement7 from "../assets/placement comp/rahul.png";
import placement8 from "../assets/placement comp/ritesh.png";
import placement9 from "../assets/placement comp/ritu raj.jpg";
import placement10 from "../assets/placement comp/shubham.png";
import placement11 from "../assets/placement comp/sonu.png";
import placement12 from "../assets/placement comp/tamanna.png";
import placement13 from "../assets/placement comp/microsoft.jpg";

import pahrmasun from "../assets/schools/pharma/placementlogo/sun.webp";
import pahrmaastellas from "../assets/schools/pharma/placementlogo/astellas.webp";
import pahrmaaurbindo from "../assets/schools/pharma/placementlogo/aurobindo.webp";
import pahrmacipla from "../assets/schools/pharma/placementlogo/cipla.webp";
import pahrmadrreddy from "../assets/schools/pharma/placementlogo/drreddy.webp";
import pahrmaglenmark from "../assets/schools/pharma/placementlogo/glenmark.webp";
import pahrmaintas from "../assets/schools/pharma/placementlogo/intas.webp";
import pahrmajohnson from "../assets/schools/pharma/placementlogo/johnson.webp";
import pahrmalupin from "../assets/schools/pharma/placementlogo/lupin.webp";
import pahrmapf from "../assets/schools/pharma/placementlogo/pf.webp";
import pahrmatorrent from "../assets/schools/pharma/placementlogo/torrent.webp";

const stats = [
  {
    id: 1,
    name: 'Highest Package',
    value: '43.6 Lakh',
    icon: (
      <svg className="w-10 h-10 text-emerald-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L14.5 9.5L20.5 10L16 14L17.5 20L12 17L6.5 20L8 14L3.5 10L9.5 9.5L12 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  { 
    id: 2, 
    name: 'Average Package', 
    value: '5.48 Lakh',
    icon: (
      <svg className="w-10 h-10 text-blue-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
  {
    id: 3,
    name: 'Years of Excellence',
    value: '15+',
    icon: (
      <svg className="w-10 h-10 text-indigo-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
];

const studentTestimonials = [
  { name: "Aastha Shrivastava", image: placement1, company: "IMH", package: "15 LPA", quote: "MDU gave me the foundation to excel in the tech industry." },
  { name: "Aman Kumar", image: placement2,  company: "Cognizant", package: "7 LPA", quote: "The practical approach to learning at MDU prepared me for real-world challenges." },
  { name: "Arman Khan", image: placement3,  company: "Wildflower Hall",  quote: "Faculty mentorship was key to my success in placements." },
  { name: "Asma Meenal", image: placement4,  company: "Accenture", package: "11 LPA", quote: "The design curriculum at MDU is industry-aligned and comprehensive." },
  { name: "Rashmi Sharma & Shivangi Shrivastav", image: placement5,  quote: "MDU's industry connections helped me secure my dream role." },
  { name: "Mohit Shokta", image: placement6,  company: "ICAR", quote: "Leadership opportunities at university prepared me for management roles." },
  { name: "Rahul Raj Kumar", image: placement7, company: "Aditya Birla Group", package: "12 LPA", quote: "The technical skills I developed at MDU are invaluable in my career." },
  { name: "Ritesh Kumar", image: placement8,  company: "Runnings Warehouse", package: "40 LPA", quote: "MDU's case-study approach to learning gave me an edge in interviews." },
  { name: "Ritu Raj", image: placement9, company: "Compo Expert", package: "5 LPA", quote: "The advanced technical courses at MDU are at par with global standards." },
  { name: "Shubham Negi", image: placement10, company: "The Sagar School", package: "12 LPA", quote: "MDU helped me build both technical and soft skills needed in the industry." },
  { name: "Sonu Thapa", image: placement11, company: "Ayavin", package: "6 LPA", quote: "The practical labs and workshops prepared me thoroughly for my role." },
  { name: "Tamanna Sharma", image: placement12, company: "IBM", package: "29.14 LPA", quote: "Research opportunities at MDU gave me a head start in my AI career." },
  { name: "Prashant Bharti", image: placementBanner, company: "Nielsen", package: "12 LPA", quote: "Research opportunities at MDU gave me a head start in my Data Science career." },
];

const recruitersImg = [
  { name: 'Google', image: googleImg },
  { name: 'Amazon', image: AmazonImg },
  { name: 'TCS', image: TcsImg },
  { name: 'Itc', image: ItcImg },
  { name: 'Accenture', image: accentImg },
  { name: 'FedEx', image: fedImg },
];

const Placement = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  
  // Auto-rotate testimonials
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === studentTestimonials.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
      
      return () => clearInterval(interval);
    }
  }, [isPaused]);
  
  // Function to handle manual navigation
  const goToTestimonial = (index) => {
    setCurrentIndex(index);
    setIsPaused(true);
    // Resume auto-rotation after 10 seconds of inactivity
    setTimeout(() => setIsPaused(false), 10000);
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <div className="w-full relative bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section with Parallax Effect */}
      <div className="relative h-[60vh] md:h-[70vh] overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: `url(${placement13})`,
            transform: 'scale(1.1)',
            filter: 'brightness(0.8)'
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-indigo-900/70"></div>
        
        <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4">
          <motion.h1 
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 tracking-tight"
          >
            Shape Your Future
          </motion.h1>
          <motion.p 
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="text-xl md:text-2xl text-gray-100 max-w-3xl"
          >
            Discover exceptional career opportunities through our industry partnerships
          </motion.p>
          
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            className="flex flex-wrap justify-center gap-4 mt-8"
          >
            <Link to="/programmes/ug-courses" className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium transition-all shadow-lg hover:shadow-emerald-500/20">
              Explore Programs
            </Link>
            <a href="#success-stories" className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/30 px-6 py-3 rounded-lg font-medium transition-all">
              View Success Stories
            </a>
          </motion.div>
        </div>
        
        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.div 
            animate={{ y: [0, 10, 0] }} 
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="flex flex-col items-center"
          >
            <span className="text-white text-sm mb-2">Scroll Down</span>
            <svg className="w-6 h-6 text-white animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </motion.div>
        </div>
      </div>

      {/* Floating Stats */}
      <div className="relative z-20 -mt-16 md:-mt-24">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-xl shadow-xl p-6 grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map((stat) => (
              <motion.div 
                key={stat.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                whileHover={{ scale: 1.02 }}
                className="flex items-center p-4 border-b-2 md:border-b-0 md:border-r-2 last:border-0 border-gray-100"
              >
                <div className="bg-gray-50 p-4 rounded-full mr-4">
                  {stat.icon}
                </div>
                <div>
                  <h3 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">{stat.value}</h3>
                  <p className="text-gray-600 font-medium">{stat.name}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="container mx-auto px-4 py-16">
        {/* About Placement Cell */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="flex flex-col md:flex-row gap-12 items-center">
            {/* Text Content */}
            <div className="w-full md:w-1/2 space-y-6">
              <div className="inline-block">
                <span className="bg-blue-100 text-blue-800 text-sm font-medium px-4 py-1 rounded-full">Career Excellence</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Transforming Careers,<br/>
                <span className="text-blue-600">Building Futures</span>
              </h2>
              
              <p className="text-gray-700 leading-relaxed">
                Maya Devi University stands as a beacon of academic excellence, dedicated to shaping future leaders. Our dynamic placement program serves as a catalyst for bridging academia with industry, empowering students to embark on fulfilling career journeys.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="p-2 bg-blue-50 rounded-md">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </div>
                    <h3 className="ml-3 text-gray-800 font-medium">Comprehensive Training</h3>
                  </div>
                  <p className="text-gray-600 text-sm ml-11">Customized skill development programs enhancing employability</p>
                </div>
                
                <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="p-2 bg-blue-50 rounded-md">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <h3 className="ml-3 text-gray-800 font-medium">Industry Network</h3>
                  </div>
                  <p className="text-gray-600 text-sm ml-11">Strong ties with 500+ leading companies across sectors</p>
                </div>
                
                <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="p-2 bg-blue-50 rounded-md">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                      </svg>
                    </div>
                    <h3 className="ml-3 text-gray-800 font-medium">Career Mentoring</h3>
                  </div>
                  <p className="text-gray-600 text-sm ml-11">One-on-one counseling by industry experts</p>
                </div>
                
                <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="p-2 bg-blue-50 rounded-md">
                      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                      </svg>
                    </div>
                    <h3 className="ml-3 text-gray-800 font-medium">Mock Interviews</h3>
                  </div>
                  <p className="text-gray-600 text-sm ml-11">Realistic preparation with industry-standard assessments</p>
                </div>
              </div>
            </div>
            
            {/* Image Column */}
            <motion.div 
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 300 }}
              className="w-full md:w-1/2 relative"
            >
              <div className="rounded-lg overflow-hidden shadow-2xl">
                <img 
                  src={placement13} 
                  alt="Placement Overview" 
                  className="w-full h-auto object-cover rounded-lg"
                />
              </div>
              
              {/* Floating card */}
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-lg shadow-xl max-w-xs hidden md:block">
                <div className="flex items-center mb-3">
                  <div className="flex -space-x-2">
                    <img className="w-8 h-8 rounded-full border-2 border-white" src={placement1} alt="Student" />
                    <img className="w-8 h-8 rounded-full border-2 border-white" src={placement2} alt="Student" />
                    <img className="w-8 h-8 rounded-full border-2 border-white" src={placement3} alt="Student" />
                  </div>
                  <span className="ml-2 text-sm font-medium text-gray-500">+400 placed this year</span>
                </div>
                <div className="bg-blue-50 rounded-md p-3">
                  <p className="text-blue-800 text-sm font-medium">
                    "92% placement record across all programs in 2024"
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.section>

        {/* Success Stories Section */}
        <motion.section 
          id="success-stories"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <span className="bg-emerald-100 text-emerald-800 text-sm font-medium px-4 py-1 rounded-full">Success Stories</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-6">Our Students' Achievement</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Meet the bright minds who've secured exceptional opportunities through our placement program.
              Their journeys exemplify the quality of education and industry preparation at Maya Devi University.
            </p>
          </div>
          
          {/* Carousel */}
          <div className="relative py-10 overflow-hidden">
            {/* Featured testimonial */}
            <div className="max-w-6xl mx-auto px-4">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8 shadow-lg">
                <div className="flex flex-col md:flex-row gap-8 items-center">
                  <div className="w-full md:w-1/3">
                    <motion.div 
                      key={currentIndex}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                      transition={{ duration: 0.5 }}
                      className="aspect-square rounded-xl overflow-hidden shadow-lg border-4 border-white"
                    >
                      <img 
                        src={studentTestimonials[currentIndex].image} 
                        alt={studentTestimonials[currentIndex].name} 
                        className="w-full h-full object-cover"
                      />
                    </motion.div>
                  </div>
                  
                  <div className="w-full md:w-2/3">
                    <div className="mb-4">
                      <svg className="w-10 h-10 text-indigo-300 mb-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                      </svg>
                      <motion.p 
                        key={`quote-${currentIndex}`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        className="text-xl md:text-2xl text-gray-700 font-medium leading-relaxed"
                      >
                        {studentTestimonials[currentIndex].quote}
                      </motion.p>
                    </div>
                    
                    <motion.div
                      key={`info-${currentIndex}`}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.5, delay: 0.2 }}
                    >
                      <h3 className="text-xl font-bold text-gray-900">{studentTestimonials[currentIndex].name}</h3>
                      <p className="text-blue-600 font-medium">{studentTestimonials[currentIndex].position} at {studentTestimonials[currentIndex].company}</p>
                      <div className="mt-2 flex items-center">
                        <span className="text-gray-600">Package:</span>
                        <span className="ml-2 bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">{studentTestimonials[currentIndex].package}</span>
                      </div>
                    </motion.div>
                    
                    {/* Navigation buttons */}
                    <div className="flex items-center justify-between mt-6">
                      <div className="flex space-x-1">
                        {studentTestimonials.map((_, idx) => (
                          <button
                            key={idx}
                            onClick={() => goToTestimonial(idx)}
                            className={`w-2 h-2 rounded-full transition-all ${
                              idx === currentIndex ? 'bg-blue-600 w-6' : 'bg-gray-300'
                            }`}
                            aria-label={`Go to testimonial ${idx + 1}`}
                          />
                        ))}
                      </div>
                      
                      <div className="flex space-x-2">
                        <button 
                          onClick={() => goToTestimonial(currentIndex === 0 ? studentTestimonials.length - 1 : currentIndex - 1)}
                          className="p-2 rounded-full bg-white shadow hover:bg-gray-50 transition-colors"
                          aria-label="Previous testimonial"
                        >
                          <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                          </svg>
                        </button>
                        <button 
                          onClick={() => goToTestimonial(currentIndex === studentTestimonials.length - 1 ? 0 : currentIndex + 1)}
                          className="p-2 rounded-full bg-white shadow hover:bg-gray-50 transition-colors"
                          aria-label="Next testimonial"
                        >
                          <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Student placement gallery */}
            <div className="mt-16">
              <h3 className="text-2xl font-bold text-center mb-8">Our Placement Stars</h3>
              
              <motion.div 
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
              >
                {studentTestimonials.map((student, idx) => (
                  <motion.div
                    key={idx}
                    variants={itemVariants}
                    whileHover={{ y: -10, transition: { type: "spring", stiffness: 300 } }}
                    className="bg-white rounded-lg shadow-md overflow-hidden group"
                  >
                    <div className="aspect-square overflow-hidden">
                      <img 
                        src={student.image} 
                        alt={student.name} 
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h4 className="font-medium text-gray-900 truncate">{student.name}</h4>
                      <p className="text-sm text-blue-600">{student.position}</p>
                      <div className="flex justify-between items-center mt-2">
                        <span className="text-xs text-gray-500">{student.company}</span>
                        <span className="text-xs bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full">{student.package}</span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
              
              {/* <div className="mt-10 text-center">
                <Link to="/alumni" className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium">
                  View All Success Stories
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </Link>
              </div> */}
            </div>
          </div>
        </motion.section>

        {/* Placement Process Section */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <span className="bg-indigo-100 text-indigo-800 text-sm font-medium px-4 py-1 rounded-full">Our Process</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-6">Placement Journey</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Our structured placement preparation process ensures students are well-equipped to face industry challenges
              and secure rewarding career opportunities.
            </p>
          </div>
          
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 h-full w-0.5 bg-blue-200"></div>
            
            {/* Timeline items */}
            <div className="relative z-10">
              {/* Item 1 */}
              <div className="flex flex-col md:flex-row items-start mb-16 md:mb-24">
                <div className="md:w-1/2 md:pr-12 md:text-right order-2 md:order-1 mt-8 md:mt-0">
                  <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-blue-500 md:border-l-0 md:border-r-4"
                  >
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Skill Assessment</h3>
                    <p className="text-gray-600">
                      Comprehensive evaluation of technical and soft skills to identify strengths and areas for improvement
                    </p>
                  </motion.div>
                </div>
                
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 flex items-center justify-center order-1 md:order-2">
                  <div className="bg-blue-600 rounded-full h-8 w-8 flex items-center justify-center text-white font-bold">1</div>
                </div>
                
                <div className="md:w-1/2 md:pl-12 order-3 mt-8 md:mt-0">
                  <div className="hidden md:block h-full"></div>
                </div>
              </div>
              
              {/* Item 2 */}
              <div className="flex flex-col md:flex-row items-start mb-16 md:mb-24">
                <div className="md:w-1/2 md:pr-12 order-2 mt-8 md:mt-0">
                  <div className="hidden md:block h-full"></div>
                </div>
                
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 flex items-center justify-center order-1">
                  <div className="bg-blue-600 rounded-full h-8 w-8 flex items-center justify-center text-white font-bold">2</div>
                </div>
                
                <div className="md:w-1/2 md:pl-12 md:text-left order-3 mt-8 md:mt-0">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-emerald-500"
                  >
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Specialized Training</h3>
                    <p className="text-gray-600">
                      Tailored workshops, mock interviews, industry talks, and aptitude preparation sessions
                    </p>
                  </motion.div>
                </div>
              </div>
              
              {/* Item 3 */}
              <div className="flex flex-col md:flex-row items-start mb-16 md:mb-24">
                <div className="md:w-1/2 md:pr-12 md:text-right order-2 md:order-1 mt-8 md:mt-0">
                  <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-indigo-500 md:border-l-0 md:border-r-4"
                  >
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Campus Recruitment</h3>
                    <p className="text-gray-600">
                      Annual placement drives with prominent companies across various sectors and industries
                    </p>
                  </motion.div>
                </div>
                
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 flex items-center justify-center order-1 md:order-2">
                  <div className="bg-blue-600 rounded-full h-8 w-8 flex items-center justify-center text-white font-bold">3</div>
                </div>
                
                <div className="md:w-1/2 md:pl-12 order-3 mt-8 md:mt-0">
                  <div className="hidden md:block h-full"></div>
                </div>
              </div>
              
              {/* Item 4 */}
              <div className="flex flex-col md:flex-row items-start">
                <div className="md:w-1/2 md:pr-12 order-2 mt-8 md:mt-0">
                  <div className="hidden md:block h-full"></div>
                </div>
                
                <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 flex items-center justify-center order-1">
                  <div className="bg-blue-600 rounded-full h-8 w-8 flex items-center justify-center text-white font-bold">4</div>
                </div>
                
                <div className="md:w-1/2 md:pl-12 md:text-left order-3 mt-8 md:mt-0">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-purple-500"
                  >
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Career Mentoring</h3>
                    <p className="text-gray-600">
                      Ongoing guidance and support even after placement to ensure career growth and success
                    </p>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Recruiters Section */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <span className="bg-blue-100 text-blue-800 text-sm font-medium px-4 py-1 rounded-full">Industry Partners</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-6">Our Recruiters</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              We've partnered with leading global and regional companies to provide outstanding career opportunities to our students.
            </p>
          </div>
          
          <div className="bg-gray-50 py-12 px-4 rounded-xl">
            <div className="max-w-6xl mx-auto">
              {/* Top recruiters */}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8 mb-12">
                {recruitersImg.map((recruiter, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                    whileHover={{ y: -5 }}
                    className="bg-white p-4 rounded-lg shadow-sm flex items-center justify-center aspect-square"
                  >
                    <img
                      src={recruiter.image}
                      alt={recruiter.name}
                      className="max-h-12 max-w-full object-contain"
                    />
                  </motion.div>
                ))}
              </div>
              
              <PlacementPartners />
              
              {/* <div className="mt-10 text-center">
                <Link to="/recruiters" className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium">
                  View All Recruiters
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </Link>
              </div> */}
            </div>
          </div>
        </motion.section>
        
        {/* FAQ Section */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <span className="bg-purple-100 text-purple-800 text-sm font-medium px-4 py-1 rounded-full">FAQ</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-6">Frequently Asked Questions</h2>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="space-y-6">
              {[
                {
                  question: "When does the placement process start?",
                  answer: "The placement process at Maya Devi University begins in the pre-final year with skill assessment and training, followed by campus recruitment drives in the final year starting from September."
                },
                {
                  question: "What is the eligibility criteria for placement?",
                  answer: "Students must maintain a minimum of 60% aggregate marks throughout their academic program with no active backlogs, and have at least 75% attendance in placement training sessions."
                },
                {
                  question: "Does the university provide placement in all disciplines?",
                  answer: "Yes, Maya Devi University facilitates placement opportunities across all disciplines through dedicated industry partnerships relevant to each field of study."
                },
                {
                  question: "Are internships available through the placement cell?",
                  answer: "Absolutely! Our placement cell coordinates summer internships, winter internships, and mandatory internship programs with our industry partners to provide practical experience."
                }
              ].map((faq, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="bg-white rounded-lg shadow-md overflow-hidden"
                >
                  <details className="group">
                    <summary className="flex items-center justify-between p-6 text-lg font-medium cursor-pointer">
                      {faq.question}
                      <span className="transition group-open:rotate-180">
                        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </span>
                    </summary>
                    <div className="px-6 pb-6 text-gray-700">
                      {faq.answer}
                    </div>
                  </details>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.section>
        
        {/* Call to Action */}
        <motion.section
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-2xl overflow-hidden shadow-xl">
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-2/3 p-8 md:p-12">
                <h2 className="text-3xl font-bold text-white mb-4">Ready to Shape Your Future?</h2>
                <p className="text-blue-100 mb-8">
                  Join Maya Devi University's prestigious programs and unlock exceptional career opportunities.
                  Our placement cell is committed to guiding your journey from campus to corporate success.
                </p>
                <div className="flex flex-wrap gap-4">
                  <Link to="https://admission.maya.edu.in/" className="bg-white text-blue-700 hover:bg-blue-50 px-6 py-3 rounded-lg font-medium transition-all shadow-lg">
                    Apply Now
                  </Link>
                  {/* <Link to="/contact" className="bg-transparent border border-white text-white hover:bg-white/10 px-6 py-3 rounded-lg font-medium transition-all">
                    Contact Placement Cell
                  </Link> */}
                </div>
              </div>
              <div className="w-full md:w-1/3 bg-blue-800 flex items-center justify-center p-8">
                <div className="text-center">
                  <div className="text-5xl font-bold text-white mb-2">92%</div>
                  <div className="text-blue-200 font-medium">Placement Rate</div>
                  <div className="h-px bg-blue-400 my-4"></div>
                  <div className="text-5xl font-bold text-white mb-2">500+</div>
                  <div className="text-blue-200 font-medium">Recruiting Partners</div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </div>

      {/* SubFooter and Footer */}
      <SubFooter />
      <Footer />
    </div>
  );
};

export default Placement;